<template>
    <div class="topNav">
        <!-- 顶部搜索 -->
        <div class="top clearfix hinner" :class="ishome?'ttop':''">
            <slot name="logo">
              <div class="left fl">
                  <img v-if="logoSrc" :src="logoSrc" alt="">
              </div>
            </slot>
            <slot name="top">
              <div class="searchBox fl">
                <el-input placeholder="请输入内容" @input="changesearchVal($event)" v-model="keyword" class="input-with-select">
                    <el-select v-model="select" @change="changeSele"  slot="prepend" placeholder="请选择">
                        <el-option v-for="item in options" 
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button slot="append" @click="intoSearch" icon="el-icon-search" v-preventReClick></el-button>
                </el-input>
              </div>
            </slot>
            <!-- 发布房源 -->
            <slot name="right">
              <div class="realeaseHouse fr">
                  <img class="sendicon" src="~@/assets/imgs/fb.png" alt="">
                  <span class="ttxt fl">发布房源</span>
                  <div class="codeBox">
                      <!-- <img class="code" src="~@/assets/imgs/applets_code.jpg" alt=""> -->
                      <div class="code" style="text-align:center;" ref="qrCodeUrl"></div>
                      <p class="txt">微信扫一扫发布房源</p>
                  </div>
              </div>
            </slot>
        </div>
        <!-- 顶部导航 -->
        <div class="Nav" :class="showTip?'tNav':''">
            <div class="navInner hinner">
                <slot name="nav">
                  <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    background-color="#d51938"
                    text-color="#fff"
                    active-text-color="#fff">
                        <el-menu-item :index="item.path" :key="item.key" v-for="item in navs">
                            <router-link :to="item.path" exact>{{item.title}}</router-link>
                        </el-menu-item>
                    </el-menu>
                </slot>
                <div class="phoneBox phoneBox1"  v-if="ishome">
                  <a :href="applink" target="_blank">APP客户端</a>
                </div>
                <div class="phoneBox" v-else>
                  手机版
                  <div class="codeBox pcodeBox">
                      <!-- <img class="code" src="~@/assets/imgs/applets_code.jpg" alt=""> -->
                      <div class="code" style="text-align:center;" ref="qrCodeUrl1"></div>
                      <p class="txt">房源房产版</p>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import preventReClick from "@/assets/js/preventReClick"; //防多次点击，重复提交
import QRCode from "qrcodejs2";
export default {
  props: ["ishome","applink"],
  data() {
    return {
      keyword: "",
      select: "1",
      selectIndex: "1",
      options: [
        {
          value: "1",
          house_type: 1,
          trade_type: 2,
          label: "二手房",
        },
        {
          value: "2",
          house_type: 1,
          trade_type: 1,
          label: "租房",
        },
        {
          value: "3",
          house_type: 2,
          trade_type: "",
          label: "商铺",
        },
        {
          value: "4",
          house_type: 3,
          trade_type: "",
          label: "写字楼",
        },
      ],
      navs: [
        { title: "首页", name: "home", path: "/home", key: 1 },
        { title: "租房", name: "zf", path: "/zf", key: 3 },
        { title: "二手房", name: "esf", path: "/esf", key: 2 },
        { title: "商铺", name: "shop", path: "/sp", key: 4 },
        { title: "写字楼", name: "xzl", path: "/xzl", key: 5 },
        { title: "找经纪人", name: "jjr", path: "/agent", key: 6 },
        { title: "求租求购", name: "ask", path: "/office", key: 7 },
      ],
      logoSrc:''
    };
  },
  created() {
      window.addEventListener('setItem', ()=> {
        this.logoSrc = JSON.parse(localStorage.getItem('houseNavObj')).logo
      })
  },
  mounted() {
    if(!this.ishome) {
      this.QRCodeMsg();
    }
  },
  computed: {
    activeIndex() {
      return "/" + this.$route.path.split("/")[1];
    },
    ...mapState(["showTip"]),
  },
  methods: {
    ...mapMutations(["changesearchVal"]),
    QRCodeMsg() {
      // 获取页面的canvas
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.$baseUrl}/house/#/?site_id=${
          this.$route.query.site_id
        }`, //this.link, // 需要转换为二维码的内容
        width: 115,
        height: 115,
      });
      var qrcode1 = new QRCode(this.$refs.qrCodeUrl1, {
        text: `${this.$baseUrl}/house/#/?site_id=${
          this.$route.query.site_id
        }`, //this.link, // 需要转换为二维码的内容
        width: 115,
        height: 115,
      });
    },
    changeSele(i) {
      this.selectIndex = i;
      this.select = this.options[i - 1].label;
    },
    intoSearch() {
      let sid = this.$route.query.site_id;
      let txt = encodeURIComponent(this.keyword.trim());
      if (this.selectIndex == 1) {
        this.$router.push({
          path: `/esf?key=${txt}&site_id=${sid}&t=${Date.now()}`,
        });
      } else if (this.selectIndex == 2) {
        this.$router.push({
          path: `/zf?key=${txt}&site_id=${sid}&t=${Date.now()}`,
        });
      } else if (this.selectIndex == 3) {
        this.$router.push({
          path: `/sp?key=${txt}&site_id=${sid}&t=${Date.now()}`,
        });
      } else {
        this.$router.push({
          path: `/xzl?key=${txt}&site_id=${sid}&t=${Date.now()}`,
        });
      }
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/less/index.less";
/deep/ .el-select-dropdown__item.selecte {
  color: #d51938 !important;
}
.el-input__inner:hover {
  border-color: #dcdfe6;
  border: 0;
}
.el-input__inner {
  border-top: 0 none !important;
  border-bottom: 0 none !important;
  border-left: 0 none !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0 none;
}
.el-select-dropdown__item {
  font-size: @ft14 !important;
  span {
    font-size: @ft14 !important;
  }
}
.topNav {
  .el-input-group__append,
  .el-input-group__prepend {
    border: 0 none !important;
    top: -2px;
  }
  .codeBox {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    width: 158px;
    height: 158px;
    z-index: 99;
    background: #fff;
    position: absolute;
    text-align: center;
    padding: 10px 0;
    display: none;
    .code {
      width: 115px;
      height: 115px;
      margin: 0 auto;
    }
    .txt {
      line-height: 0;
      color: #666;
      margin-top: 15px;
    }
  }
  .top {
    margin: 68px auto 27px;
    &.ttop{
      margin:30px auto;
    }
    .left {
      width: 227px;
      height: 55px;
      img {
        width: 227px;
        height: 55px;
        vertical-align: middle;
      }
    }
    .searchBox {
      width: 510px;
      margin: 6px 100px 0;
      height: 45px;
      font-size: @ft12;
      border-radius: 5px;
      border: 1px solid #eee;
      .el-input {
        font-size: @ft12 !important;
      }
      .el-input-group__append {
        text-align: center !important;
        color: #fff;
        height: 45px;
        background: #d51938 !important;
        width: 70px;
        border: 0 none !important;
      }
      .el-input-group__prepend {
        background: none !important;
      }
      .el-select-dropdown__item {
        font-size: @ft14 !important;
        span {
          font-size: @ft14 !important;
        }
      }
      .el-input__inner {
        font-size: @ft14 !important;
        background: none !important;
        height: 45px;
        border-right: 1px solid #eee;
      }
    }
    .realeaseHouse {
      background: #fb9031;
      border-radius: 5px;
      line-height: 45px;
      width: 158px;
      color: #fff;
      cursor: pointer;
      margin: 6px 0 0;
      text-align: center;
      position: relative;
      &:hover {
        .codeBox {
          display: block;
        }
      }
      .sendicon {
        width: 24px;
        height: 24px;
        float: left;
        vertical-align: middle;
        margin: 10px 3px 0 30px;
      }
      .codeBox {
        width: 158px;
        height: 158px;
        z-index: 99;
        background: #fff;
        position: absolute;
        text-align: center;
        top: 46px;
        padding: 10px 0;
        // display: none;
        .code {
          width: 115px;
          height: 115px;
        }
        .txt {
          line-height: 0;
          color: #666;
          font-weight: bold;
        }
      }
    }
  }
  .Nav {
    background: #d51938;
    height: 50px;
    line-height: 50px;
    height: 50px;
    z-index: 1;
    // overflow: hidden;
    &.tNav {
      position: fixed;
      top: 0;
      width: 100%;
    }
    .navInner {
      height: 50px;
      position: relative;
      a {
        color: #fff;
      }
      .phoneBox {
        position: absolute;
        right: 16px;
        top: 0;
        color: #fff;
        cursor: pointer;
        &:hover {
          .pcodeBox {
            display: block;
          }
        }
        .pcodeBox {
          right: -17px;
        }
        &::after,
        &::before {
          content: "";
          display: inline-block;
          position: absolute;
        }
        &::after {
          width: 12px;
          height: 12px;
          top: 19px;
          right: -17px;
          background: url(~@/assets/imgs/aw.png) no-repeat;
        }
        &::before {
          width: 20px;
          height: 20px;
          top: 15px;
          left: -25px;
          background: url(~@/assets/imgs/picon.png) no-repeat;
        }
        &.phoneBox1{
          a{
            font-size:18px;
          }
          &::after{
            display: none;
          }
        }
      }
    }
    li {
      line-height: 48px;
      height: 50px;
      &.el-menu-item {
        padding: 0;
      }
      &.is-active {
        border-bottom: 0 !important;
        a {
          border: 0;
          background: #aa142d;
        }
      }
      a {
        display: inline-block;
        padding: 0 29px;
        font-size: @fht18;
      }
    }
  }
  .el-select {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/topNav.vue